"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Variables_1 = require("../../Variables");
var Utility_1 = require("../../Utility");
var SVG = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  font-size: 1.5em;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  flex-shrink: 0;\n  user-select: none;\n\n  /* Fill */\n  ", "\n\n  /* Colors */\n  ", "\n\n  ", "\n\n  &.t2-xxl {\n    width: 26px;\n    height: 26px;\n  }\n  &.t2-xl {\n    width: 24px;\n    height: 24px;\n  }\n  &.t2-lg {\n    width: 22px;\n    height: 22px;\n  }\n  &.t2-md {\n    width: 20px;\n    height: 20px;\n  }\n  &.t2-sm {\n    width: 18px;\n    height: 18px;\n  }\n  &.t2-xs {\n    width: 16px;\n    height: 16px;\n  }\n  &.t2-xxs {\n    width: 14px;\n    height: 14px;\n  }\n"], ["\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  font-size: 1.5em;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  flex-shrink: 0;\n  user-select: none;\n\n  /* Fill */\n  ", "\n\n  /* Colors */\n  ", "\n\n  ", "\n\n  &.t2-xxl {\n    width: 26px;\n    height: 26px;\n  }\n  &.t2-xl {\n    width: 24px;\n    height: 24px;\n  }\n  &.t2-lg {\n    width: 22px;\n    height: 22px;\n  }\n  &.t2-md {\n    width: 20px;\n    height: 20px;\n  }\n  &.t2-sm {\n    width: 18px;\n    height: 18px;\n  }\n  &.t2-xs {\n    width: 16px;\n    height: 16px;\n  }\n  &.t2-xxs {\n    width: 14px;\n    height: 14px;\n  }\n"])), function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'currentColor' : _b;
    return "fill: ".concat(fill, ";");
}, function (_a) {
    var color = _a.color;
    return (color ? "color: ".concat(Variables_1.color[color], ";") : '');
}, function (_a) {
    var responsive = _a.responsive;
    return responsive
        ? "@media screen and (min-width: 768px) {\n    &.t2-xxl {\n      width: 28px;\n      height: 28px;\n    }\n    &.t2-xl {\n      width: 26px;\n      height: 26px;\n    }\n    &.t2-lg {\n      width: 24px;\n      height: 24px;\n    }\n    &.t2-md {\n      width: 22px;\n      height: 22px;\n    }\n    &.t2-sm {\n      width: 20px;\n      height: 20px;\n    }\n    &.t2-xs {\n      width: 18px;\n      height: 18px;\n    }\n    &.t2-xxs {\n      width: 16px;\n      height: 16px;\n    }\n  }"
        : '';
});
var createSvgIcon = function (path, displayName) {
    return React.memo(React.forwardRef(function (props, ref) {
        return (React.createElement(SVG, __assign({ viewBox: "0 0 24 24", "data-testid": "".concat(displayName, "Icon"), ref: ref }, (0, Utility_1.handleSize)((0, Utility_1.handleUtility)(props))), path));
    }));
};
exports.default = createSvgIcon;
var templateObject_1;
